export const DEFAULT_EDITOR_JSON = {
  blocks: [
    {
      key: '8o1am',
      data: {},
      text: '',
      type: 'unstyled',
      depth: 0,
      entityRanges: [],
      inlineStyleRanges: [],
    },
  ],
  entityMap: {},
};

export const DEFAULT_TIPTAP_JSON = {
  type: 'doc',
  content: [{ type: 'paragraph', content: [{ text: '', type: 'text' }] }],
};
